import { Injectable } from '@angular/core';
import { EstimateDataDispatcher } from '../estimate-data/estimate-data.dispatcher';
import { Document } from '../document-data/document.model';
import { Toggles } from '../features-data/sub-models/toggles.model';
import { DocumentTypesEnum } from '../document-data/document-data.data';

@Injectable()
export class DocumentDetailService {
  constructor(private _estimateDataDispatcher: EstimateDataDispatcher) {}

  triggerJobDialog(toggles: Toggles, document: Document) {
    if (!toggles.isAllAccess(Toggles.KEYS.JOB)) {
      return;
    }

    const clientId = document.billing.referenceId;

    const shouldTriggerDialog =
      document.isNew() &&
      document.documentType === DocumentTypesEnum.estimate &&
      !!clientId;

    if (shouldTriggerDialog) {
      return this._estimateDataDispatcher.enableJobDialog(
        clientId,
        document.id
      );
    }

    return;
  }
}
